import { useCurrentUser } from 'src/hooks';
import { FilterOrgItems } from './FilterOrgItems';
import { FilterPersonalItems } from './FilterPersonalItems';

type Props = {
  closeDropdown: () => void;
  showMainLabel: boolean;
  isMobile: boolean;
};

/**
 * This component is used to render the filter items for the cart history page.
 * It is used in the FilterByDropdown and MobileDropdown components.
 * @param closeDropdown - function to close the dropdown
 * @param showMainLabel - boolean to include the "Filter by:" label, this will only be shown on page sizes where MobileDropdown.tsx is used
 * @param isMobile - boolean to know if we are using the mobile dropdown
 * @returns
 */
export const FilterItems = ({
  closeDropdown,
  showMainLabel,
  isMobile,
}: Props) => {
  const { user } = useCurrentUser();

  const isOrg = user?.subscription?.tier === 'organization';
  const isAdminOrApprover =
    isOrg &&
    (user?.subscription?.role === 'admin' ||
      user?.subscription?.role === 'approver');

  return (
    <div className='z-20 flex min-w-[200px] max-w-min flex-col items-start justify-center rounded-lg bg-cloudGray font-secondary xs:min-w-[240px]'>
      <MainLabelWrapper showMainLabel={showMainLabel}>
        {isAdminOrApprover && <FilterOrgItems handleClick={closeDropdown} />}
        <FilterPersonalItems
          handleClick={closeDropdown}
          showLabel={isAdminOrApprover}
          isMobile={isMobile}
        />
      </MainLabelWrapper>
    </div>
  );
};

const MainLabelWrapper = ({
  showMainLabel,
  children,
}: {
  showMainLabel: boolean;
  children: React.ReactNode;
}) => {
  if (showMainLabel) {
    return (
      <div className='flex w-full flex-col items-start gap-2 pt-3'>
        <span className='-mb-3 whitespace-nowrap pl-3 font-secondary text-primary-dark'>
          Filter by:
        </span>
        <div className='flex w-full flex-col items-start pl-3'>{children}</div>
      </div>
    );
  }

  return <>{children}</>;
};
